import { Box, List, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { PermissionGate } from 'modules/permission';
import useMenu from 'store/menu';
import { NavItemType } from 'types/menu';

import NavCollapse from './NavCollapse';
import NavItem from './NavItem';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

interface Props {
  item: NavItemType;
}

const NavGroup = ({ item }: Props) => {
  const theme = useTheme();
  const drawerOpen = useMenu((state) => state.drawerOpen);

  const navCollapse = item.children?.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return (
          <PermissionGate permission={menuItem.permission} key={menuItem.id}>
            <NavCollapse menu={menuItem} level={1} />
          </PermissionGate>
        );
      case 'item':
        return (
          <PermissionGate permission={menuItem.permission} key={menuItem.id}>
            <NavItem item={menuItem} level={1} />
          </PermissionGate>
        );

      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        item.title &&
        drawerOpen && (
          <Box sx={{ pl: 3, mb: 1.5 }}>
            <Typography variant="subtitle2" color={theme.palette.mode === 'dark' ? 'textSecondary' : 'text.secondary'}>
              {item.title}
            </Typography>
            {item.caption && (
              <Typography variant="caption" color="secondary">
                {item.caption}
              </Typography>
            )}
          </Box>
        )
      }
      sx={{ mt: drawerOpen && item.title ? 1.5 : 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
};

export default NavGroup;
